<template>
	<button
		type="button"
		class="ov-table-check"
		:class="{
			'ov-table-check--on': checked && !indeterminate,
			'ov-table-check--indeterminate': indeterminate,
		}"
		role="checkbox"
		:aria-checked="indeterminate ? 'mixed' : checked"
		@click.stop="$emit('toggle')"
	>
		<span class="ov-table-check__box">
			<i v-if="checked && !indeterminate" class="la la-check ov-table-check__icon" />
			<span v-else-if="indeterminate" class="ov-table-check__bar" />
		</span>
	</button>
</template>

<script>
export default {
	name: "OvTableCheck",
	props: {
		checked: { type: Boolean, default: false },
		indeterminate: { type: Boolean, default: false },
	},
	emits: ["toggle"],
};
</script>
